export default __webpack_public_path__ + "static/media/safe3.97252b6e.png";